// @helpers
const { APIGet, APIPost } = require('utilities/APIRequestHelper');

// @constants
const actionTypes = require('constants/actionTypes');


const getBankNameRequest = () => ({
    type: actionTypes.FETCH_BANK_ENTITY_REQUEST
});

const getBankNameFailure = error => ({
    type: actionTypes.FETCH_BANK_ENTITY_FAILURE,
    payload: {
        error
    }
});

const getBankNameSuccess = (bankName, lastBankName) => ({
    type: actionTypes.FETCH_BANK_ENTITY_SUCCESS,
    payload: {
        bankName,
        lastBankName
    }
});

const rebootBankName = () => ({
    type: actionTypes.FETCH_BANK_ENTITY_RESET
});

const getBankNameFromIban = (iban, lastBankName) => dispatch => {
    dispatch(getBankNameRequest());

    return APIPost({
        dispatch,
        endpoint: 'bankEntityIban',
        params: {
            query: {
                iban
            }
        }
    })
    .then(response => dispatch(getBankNameSuccess(response.bankName, lastBankName)))
    .catch(
        response => {
            if (!!response.error) {
                dispatch(getBankNameFailure(response.error.description))
            } else {
                throw response;
            }
        }
    );
};

const getBankNameFromBic = bic => dispatch => {
    dispatch(getBankNameRequest());

    return APIGet({
        dispatch,
        endpoint: 'bankEntityBic',
        params: {
            query: {
                bic
            }
        }
    })
    .then(response => dispatch(getBankNameSuccess(response.bankName)))
    .catch(
        response => {
            if (!!response.error) {
                dispatch(getBankNameFailure(response.error.description))
            } else {
                throw response;
            }
        }
    );
};

const resetBankName = () => dispatch => {
    dispatch(rebootBankName());
};

module.exports = {
    getBankNameFromIban,
    getBankNameFromBic,
    resetBankName
}